<template>
  <input
    :type="type"
    :id="idAttr"
    :name="nameAttr"
    :class="{'error': errors.length > 0}"
    :value="value"
    maxlength="12"
    @keyup="onKeyUp"
    @blur="onBlur"
    @focus="(e) => { $emit('focus', e) }"
  >

</template>

<script>
import { stripDigits, toInitials } from '../../utils/string'

/* @flow */
export default {
  name: 'InitialsInput',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    errors: {
      type: Array,
      default: () => []
    },
    prefix: {
      type: String,
      default: 'customer'
    }
  },
  computed: {
    idAttr: function () { return `${this.prefix}-${this.name}` },
    nameAttr: function () { return `${this.prefix}[${this.name}]` }
  },
  methods: {
    onKeyUp: function (event) {
      let value = event.target.value

      if (event.keyCode !== 8 && event.keyCode !== 46 && !(event.keyCode > 36 && event.keyCode < 41)) {
        value = stripDigits(toInitials(value))
      }

      this.emitValue(value)
    },
    onBlur: function () {
      this.emitValue(toInitials(this.value))
    },
    emitValue: function (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/registration-form/InitialsInput.vue